<template>
  <div class="addKeyWork-container">
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="500px"
      class="addKeywork-dialog"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <div slot="title">添加关键词</div>
      <el-form
        label-position="left"
        :model="keyWordData"
        ref="keyWordRef"
        label-width="80px"
        class="addKeyWork-form"
        center
        :rules="rules"
      >
        <el-form-item label="分类" prop="classId">
          <el-select
            v-model="keyWordData.classId"
            :disabled="isDisabled"
            placeholder="请选择分类"
          >
            <el-option
              v-for="item in keyWordOptions"
              :key="item.classId"
              :label="item.wordTypeName"
              :value="item.classId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键词" prop="wordName">
          <el-input
            class="word-name-input"
            clearable
            v-model.trim="keyWordData.wordName"
            maxlength="32"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="addKeyWork-list-wrap">
        <!-- <div class="addKeyWork-title">已有关键词</div> -->
        <div v-if="existenceKeyWorkList.length">
          <el-tag
            class="keyWork-tag"
            v-for="(item, index) in existenceKeyWorkList"
            :key="index"
            closable
            type="small"
            @close="delTag(item)"
          >
            {{ item.wordName }}
          </el-tag>
        </div>
        <div class="empty-tip" v-else>暂无已添加关键词</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel" style="margin-right:20px"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script setup lang="ts">
import {
  getConsultList,
  // addSensitiveWord,
  createRuleApi,
  updateRuleApi,
  delConsult,
  ruleListApi,
} from "@/api/keyWords/index.js";
export default {
  name: "addKeywork",
  data() {
    return {
      /** 控制弹窗显示隐藏 */
      dialogVisible: false,
      /** 新增关键 */
      keyWordData: {
        /** 关键词分类id */
        classId: "",
        /** 关键词 */
        wordName: "",
      },
      /** 控制分类是否可选 */
      isDisabled: false,
      /** 分类数据 */
      keyWordOptions: [],
      /** 已有关键词列表 */
      existenceKeyWorkList: [],
      /** 表单校验规则 */
      rules: {
        /** 关键词分类 */
        classId: [
          { required: true, message: "请选择关键词分类", trigger: "blur" },
        ],
        /** 关键词 */
        wordName: [
          { required: true, message: "请选择填写关键词", trigger: "blur" },
        ],
      },
      level: 1,
      /** 当前选中的类型数据 */
      currentData: {},
      // treeRef:null
    };
  },
  methods: {
    /** 打开弹窗初始化，由父组件调用 itemTree 选中值*/
    init(typeId, options, itemTree) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        console.log("typeId+++++", typeId);
        console.log("options+++++", options);
        console.log("itemTree+++++", itemTree);
        // this.treeRef = treeRef
        this.keyWordData.classId = typeId;
        /** 获取当前所选中的树形结构数据 */
        this.currentData = itemTree || {};
        console.log("his.currentData+++", this.currentData);

        /** 初始化数据 */
        this.existenceKeyWorkList = [];
        this.isDisabled = true;
        this.keyWordData.wordName = "";
        /** typeId === "startId" 为顶级节点 没有数据*/
        if (typeId === "startId") {
          this.keyWordData.classId = "";
          this.isDisabled = false;
          this.existenceKeyWorkList = [];
        } else {
          /** 获取已有关键词列表 */
          this.getExistenceKeyWorkList();
        }
        let keyWordOptions = [];
        console.log("this.level+++");

        // if (this.level == 2) {
        //   console.log("进来了吗？");

        //   JSON.parse(JSON.stringify(options.children)).forEach((item) => {
        //     keyWordOptions = [item, ...keyWordOptions];
        //   });
        // } else {
        /** 新版本只能到二级节点 */
        if (Array.isArray(options) && options.length) {
          JSON.parse(JSON.stringify(options[0].children)).forEach((item) => {
            keyWordOptions.push(item);
          });
        }
        // }
        this.keyWordOptions = keyWordOptions;
        console.log("this.keyWordOptions+++++", this.keyWordOptions);
      });
    },

    /** 获取已有的关键词列表数据 */
    getExistenceKeyWorkList() {
      // if (this.isNewEdition) {
      let requestParams = {
        classId: this.currentData.ruleId || this.currentData.classId,
        wordTypeId: this.currentData.classId,
        // pageNum: 1,
        // pageSize: 9999,
        wordName: this.currentData.wordTypeName,
      };
      ruleListApi(requestParams, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res && res.error && res.error.code == 200) {
            this.existenceKeyWorkList = res.data.result || [];
            console.log("this.existenceKeyWorkLis++", this.existenceKeyWorkLis);
          }
        })
        .catch((err) => {
          console.log(err, "errr");
        });
      // } else {
      //   /** 旧版 */
      //   /** 请求参数 */
      //   let requestParams = {
      //     pageNum: 1,
      //     pageSize: 99999,
      //     classId: "",
      //   };
      //   getConsultList(
      //     Object.assign(requestParams, this.keyWordData),
      //     localStorage.getItem("Authorization"),
      //     true
      //   )
      //     .then((res) => {
      //       if (res && res.error && res.error.code == 200) {
      //         this.existenceKeyWorkList = [];
      //         res.data.ruleList.forEach((item) => {
      //           this.existenceKeyWorkList.push({
      //             wordName: item.wordName,
      //             ruleId: item.ruleId,
      //           });
      //         });
      //       }
      //     })
      //     .catch((err) => {
      //       console.log(err, "errr");
      //     });
      // }
    },

    /** 点击删除已有关键词标签 */
    delTag(item) {
      /** 因为腾讯不允许为词组中不存在关键词
       * 所以这里要当拥有关键词后,这里必须要限制
       * 不能删除最后一个关键词
       */
      if (this.existenceKeyWorkList && this.existenceKeyWorkList.length === 1) {
        this.$message.closeAll();
        return this.$message.warning(
          "当前词组请保留至少一个关键词,如果需要删除整组,请通过左侧列表删除"
        );
      }
      /** 点击删除关键词 */
      this.$confirm("您确定删除该关键词吗？提交后将无法撤回", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        iconClass: "el-icon-warning",
        customClass: "delete-messege",
        center: true,
      })
        .then((res) => {
          /** 取出列表的所有关键词名称组成数组 */
          let wordNameList = this.existenceKeyWorkList.map((item) => {
            return item.wordName;
          });
          /** 去除选中的 */
          let wordName = wordNameList.filter((wordNameListItem) => {
            return wordNameListItem != item.wordName;
          });
          console.log("item++++++223", item);
          let requestParams = {
            /** 需要删除的名称 */
            delWordName: item.wordName,
            /** 关键词规则名称，长度限制1~20个字符 */
            name: this.currentData.wordTypeName,
            /** 分类ID */
            ruleId: item.ruleId,
            /** 去除要删除的关键词后的数组 */
            wordName,
          };
          console.log("没有这里来？");

          updateRuleApi(
            requestParams,
            localStorage.getItem("Authorization")
          ).then((res) => {
            if (res && res.error && res.error.code == 200) {
              this.$message.success("操作成功");
              /** 删除后刷新当前关键词列表 */
              this.getExistenceKeyWorkList(this.getSensiListParams);
              /** 同时通知父组件刷新表格，需要保持内外数据同步，以免给用户带来歧义 */
              this.$emit("addSuccess");
            }
          });
        })
        .catch((action) => {
          // this.$message("取消删除");
        });

      // delConsult
      // this.$confirm("您确定删除该关键词吗？提交后将无法撤回", {
      //     distinguishCancelAndClose: true,
      //     closeOnClickModal: false,
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: 'warning',
      //     iconClass: 'el-icon-warning',
      //     customClass: 'delete-messege',
      //     center: true
      //   })
      //   .then((res) => {
      //     delConsult(item.ruleId,localStorage.getItem("Authorization")).then(res => {
      //       if(res.error.code == 200){
      //         this.$message.success('删除成功！')
      //         this.wordNames = this.wordNames.filter(v=>{
      //         return v.ruleId!=item.ruleId
      //         })
      //         this.deleWordNames.push(item)
      //       }
      //     }).catch(err => {
      //       that.$message.error('删除失败，请重试！')
      //       console.log(err,'errr')
      //     })
      //   })
      //   .catch((action) => {
      //     this.$message("取消删除");
      //   });

      //过滤原始数据
      // this.$confirm("您确定要删除该关键词吗？删除后将无法恢复", {
      //   distinguishCancelAndClose: true,
      //   closeOnClickModal: false,
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      //   customClass: "delete-messege",
      //   center: true,
      // })
      //   .then((res) => {
      //     delConsult(item.ruleId, localStorage.getItem("Authorization"))
      //       .then((res) => {
      //         if (res && res.error && res.error.code == 200) {
      //           this.existenceKeyWorkList = this.existenceKeyWorkList.filter(
      //             (keyWorkItem) => {
      //               return keyWorkItem.ruleId != item.ruleId;
      //             }
      //           );
      //           this.$message.success("操作成功！");
      //         } else {
      //         }
      //       })
      //       .catch((err) => {
      //         this.$message.error("删除失败，请重试！");
      //         console.log(err, "errr");
      //       });
      //   })
      //   .catch((action) => {});
    },

    /** 点击取消 */
    cancel() {
      this.dialogVisible = false;
    },

    /** 点击确认 */
    confirm() {
      /** 防抖 */
      let isSubmit = true;
      this.$refs["keyWordRef"].validate(async (valid) => {
        if (valid) {
          /** 判断该词组中关键词是否已存在，其他词组存在前端无法拦截，由接口拦截 */
          if (!this.checkHasKeyWork()) {
            /** 不存在 可以添加 */
            await this.addKeyWord();
          } else {
            /** 存在 */
            this.$message.closeAll()
            this.$message.error("已存在该关键词，请勿重复添加！");
          }
        } else {
          console.log("error submit!!");
          return false;
        }
        isSubmit = false;
      });
    },

    /** 添加关键词 */
    addKeyWord() {
      if (!this.existenceKeyWorkList.length) {
        /** 如果是没有值，证明是第一次添加新词，那么走新增接口 */
        let requestParams = {
          name: this.currentData.wordTypeName,
          wordName: this.keyWordData.wordName,
          wordTypeId: this.keyWordData.classId,
        };
        createRuleApi(requestParams, localStorage.getItem("Authorization"))
          .then((res) => {
            if (res && res.error && res.error.code == 200) {
              this.$message.success("添加成功！");
              /** 关闭弹窗 */
              this.dialogVisible = false;
              /** 清除分类 */
              this.keyWordData.classId = "";
              /** 通知父组件 */
              this.$emit("addSuccess");
            } else {
              this.$message.error(res.error.message);
            }
          })
          .catch((err) => {
            this.$message.error("系统繁忙，稍后再试");
          });
      } else {
        /** 如果有值，证明是非添加第一次新词，那么走更新接口 */
        let wordNameList = [];
        this.existenceKeyWorkList.forEach((item) => {
          wordNameList.push(item.wordName);
        });

        /** 把要新增的关键词加进行，组成最新的数据传给接口 */
        wordNameList.push(this.keyWordData.wordName);
        let requestParams = {
          name: this.currentData.wordTypeName,
          ruleId: this.currentData.ruleId || this.currentData.classId,
          wordName: wordNameList,
        };
        console.log("requestParams++", requestParams);

        updateRuleApi(requestParams, localStorage.getItem("Authorization"))
          .then((res) => {
            if (res && res.error && res.error.code == 200) {
              this.$message.success("添加成功！");
              /** 关闭弹窗 */
              this.dialogVisible = false;
              /** 通知父组件 */
              this.$emit("addSuccess");
            }
          })
          .catch((err) => {
            console.log(err, "errr");
            this.$message.error("系统繁忙，稍后再试");
          });
      }
    },

    /** 判断该关键词是否已存在
     * 这里只能拦截当前词组中存在该词的情况，
     * 而需求是不能重复添加任意词组中存在的词，
     * 前端只能拦截到当前词组存在的重复词，如果存在于其他词组，得由接口拦截
     */
    checkHasKeyWork() {
      console.log("this.keyWordData.wordName+++",this.keyWordData.wordName);
      console.log("this.existenceKeyWorkList+++",this.existenceKeyWorkList);
      
      /** 词组中存在词的时候，看看里面是否有存在相同的词，不能添加重复的词 */
      if (this.existenceKeyWorkList && this.existenceKeyWorkList.length) {
        return this.existenceKeyWorkList.some((item, index) => {
          console.log("item.wordName");
          
          return item.wordName == this.keyWordData.wordName;
        });
      } else {
        /** 词组中不存在词的时候，直接返回false */
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.addKeyWork-container {
  /deep/ .add-dialog {
    color: #000;
  }
  .el-dialog__body {
    padding: 0 20px 20px;
    font-size: 14px;
    word-break: break-all;
    .addKeyWork-list-wrap {
      padding-left: 25px;
      padding-bottom: 20px;
      border-bottom: 1px solid #f2f2f2;
      max-height: 250px;
      overflow-y: scroll;
      padding-top: 20px;

      .keyWork-tag {
        margin-right: 6px;
        margin-bottom: 6px;
      }
      .empty-tip {
        text-align: center;
        line-height: 60px;
        color: #8f9495;
      }
      .addKeyWork-title {
        padding: 20px 0 15px;
      }
      .addKeyWork-title {
        padding: 5px;
        background-color: #f1f8ff;
        color: #8f9495;
      }
    }
  }
  .addKeyWork-form {
    padding: 20px 0 0;
    border-bottom: 1px solid #f2f2f2;
    border-top: 1px solid #f2f2f2;
    .el-form-item {
      padding-left: 25px;
    }
    .el-select {
      width: 80%;
    }
    .word-name-input {
      width: 80%;
    }
  }
}
</style>
